// ROOTS brandmark — a stylised tree crown with a visible root network.
// Inherits color via currentColor so it themes cleanly on any background.
export function RootsMark({ className = "h-5 w-5", strokeWidth = 1.6 }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* canopy crown */}
      <circle cx="12" cy="6" r="3.1" fill="currentColor" stroke="none" />
      <circle cx="8.1" cy="8" r="2.3" fill="currentColor" stroke="none" />
      <circle cx="15.9" cy="8" r="2.3" fill="currentColor" stroke="none" />
      {/* trunk */}
      <path d="M12 8.6V13.4" />
      {/* root network */}
      <path d="M12 13.4C11.2 15.1 8.6 15.4 6.4 18.1" />
      <path d="M12 13.4C12.8 15.1 15.4 15.4 17.6 18.1" />
      <path d="M12 13.4V19.2" />
      {/* root tips */}
      <path d="M6.4 18.1l-1.3 1.9" />
      <path d="M17.6 18.1l1.3 1.9" />
      <path d="M12 19.2v2" />
    </svg>
  );
}

export default RootsMark;
